import { ValidatorRuleType } from "@tCooneyBrothers/Common/Utilities/validate";

export const intialErrorFormState = {
    accountNumber: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const existingCustomerValidatorConfig: ValidatorConfigType = {
    accountNumber: {
        required: true,
        label: "Account Number",
    },
    firstName: {
        required: true,
        minLength: 2,
        label: "First Name",
    },
    lastName: {
        required: true,
        minLength: 2,
        label: "Last Name",
    },
    email: {
        required: true,
        regex: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
        label: "Email Address",
    },
    phone: {
        required: true,
        label: "Phone Number",
        maxLength: 12,
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
    },
};
